module.exports = __webpack_public_path__ + "static/media/ADDLABEL.24570613.svg";